import React from 'react'
import styles from './svg.module.scss'

const shield = ({
  viewBox = '0 0 32 32',
  color = 'primaryColor',
  size = 'auto',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      className={styles[color]}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2852 22.574C19.2408 24.8411 16.9095 25.6857 16 25.9427C15.0905 25.6857 12.7592 24.8411 10.7148 22.574C8.7162 20.3576 6.8083 16.58 7.01529 10.1095C8.57786 9.47126 10.5624 8.56141 12.2835 7.77101L12.4921 7.67524L12.4921 7.67521C13.5541 7.18748 14.5181 6.7447 15.2654 6.41664C15.5664 6.28448 15.8181 6.17719 16.0181 6.09602C16.2391 6.18002 16.5209 6.29305 16.8574 6.43265C17.6961 6.78064 18.7952 7.26073 19.9663 7.78114C21.205 8.33162 22.5677 8.94712 23.7415 9.47727C24.1882 9.67902 24.6076 9.86842 24.9823 10.0372C25.2059 16.5519 23.2912 20.3494 21.2852 22.574ZM11.6645 5.85448C9.3407 6.92176 6.64931 8.15789 5.08525 8.71074C3.99405 24.1382 13.703 27.4196 15.6601 27.9225C15.8866 27.9806 16.1134 27.9806 16.3399 27.9225C18.297 27.4197 28.0059 24.1382 26.9147 8.71074C26.363 8.46698 25.5294 8.09037 24.5634 7.65398L24.5633 7.65394C21.2826 6.17181 16.4752 4 16 4C15.7022 4 13.8452 4.85289 11.6645 5.85447L11.6645 5.85448ZM16.3958 5.95323C16.4358 5.94095 16.4287 5.94574 16.387 5.956L16.3958 5.95323ZM15.636 5.96076L15.6396 5.96182C15.5947 5.95158 15.5882 5.94677 15.636 5.96076ZM19.8734 14.3677C20.2639 13.9771 20.2639 13.344 19.8734 12.9535C19.4828 12.5629 18.8497 12.5629 18.4592 12.9535L15.0568 16.3558L13.5977 14.8966C13.2072 14.5061 12.574 14.5061 12.1835 14.8966C11.7929 15.2871 11.7929 15.9203 12.1835 16.3108L14.3497 18.4771C14.7403 18.8676 15.3734 18.8676 15.7639 18.4771L19.8734 14.3677Z"
      />
    </svg>
  )
}

export default shield
